const VALID_LOCALES = [
    "br",
    "de",
    "en",
    "es",
    "fr",
    "hu",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "ru",
    "zh"
] as const;

type ExtractTypeFromArray<T extends Iterable<unknown>> = T extends Iterable<
    infer E
>
    ? E
    : never;

export type SupportedLocales = ExtractTypeFromArray<typeof VALID_LOCALES>;

export const isValidLocale = (locale: string): locale is SupportedLocales =>
    VALID_LOCALES.includes(locale as SupportedLocales);
